
import axios from "axios";
import { getChestApiUrl } from "../../helpers";


const getSearchQuery = ({ session }) => {
    try {
        if (session) {
            const url = `${getChestApiUrl()}/chestApi/data/f/search?s=${session}`;

            return axios.get(url).then(({ data }) => data)
            //return fetch(url).then(r => r.json()).catch(err => console.log("[ERROR]:", err));

        } else {
            throw new Error(' NO DATA SESSION  ');
        }
    } catch (err) {
        throw err;
    }
}

export default {
    getSearchQuery
}